var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"slide-img-preview",attrs:{"id":"preview","src":_vm.slidePreviewURL}})
}
var staticRenderFns = []

export { render, staticRenderFns }